import { html } from 'lit-element';

import { Form, mapFormDispatchToEvents } from '@elab/components/connected/forms/Form';
import { COMPONENT_CONNECT, COMPONENT_DISCONNECT } from '@elab/core/utils/dynaReduxHelpers';
import connect from '@elab/core/store/connect';
import { actions as coreActions } from '@elab/core/store/core';

import { getReducers, getSagaFactory } from './redux';

const parentForms = {
    registrationForm: 'registrationForm',
    'physical-loyalty-enrollment-form': 'physical-loyalty-card',
    checkoutRegistrationForm: 'checkout-registration',
};

export class PinCodeForm extends Form {
    static get properties() {
        return {
            parentFormId: { type: String, attribute: 'parent-form-id' },
        };
    }

    constructor() {
        super();
        this.parentFormId = 'registrationForm';
    }

    render() {
        return html`
            <form
                class="pin-code-form ${this.formClassName}"
                @focus=${this.handleFocus}
                @blur=${this.handleBlur}
                @submit=${this.submit}
            >
                <v-slot name="content"></v-slot>
            </form>
        `;
    }
}

const mapDispatchToEvents = (dispatch, ctx) => ({
    [COMPONENT_CONNECT]: () => {
        const storeName = ctx.storeName || ctx.formId;
        const parentStoreName = parentForms[ctx.parentFormId];
        dispatch(coreActions.addReducer(ctx.storeName, getReducers(storeName)));

        const saga = getSagaFactory({ storeName, parentStoreName })(ctx.formId);
        dispatch(coreActions.addSaga(storeName, saga));
    },
    [COMPONENT_DISCONNECT]: () => {
        const storeName = ctx.storeName || ctx.formId;
        dispatch(coreActions.removeSaga(storeName));
        dispatch(coreActions.removeReducer(storeName));
    },
    ...mapFormDispatchToEvents(dispatch, ctx),
});

export default () =>
    customElements.define('e2-pincode-form', connect(null, mapDispatchToEvents)(PinCodeForm));
